import { Button, Card, CardContent, Typography } from "@mui/material";
import { useGetChannelConnections } from "hooks/useGetChannelConnections";
import { FaCircle, FaInstagram, FaTelegram, FaWhatsapp } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { CHANNEL_STATUS } from "../Whatsapp/WhatsappConnect";
import { MdAdd, MdScience } from "react-icons/md";
import { useState } from "react";
import { useSelector } from "react-redux";
import { getAgents } from "redux/selectors/getAgents";
import CreateChannelDialog from "./CreateChannelDialog";

const SOURCE_ICONS: Record<string, JSX.Element> = {
  WHATSAPP: <FaWhatsapp />,
  TELEGRAM: <FaTelegram />,
  INSTAGRAM: <FaInstagram />,
  TEST_SANDBOX: <MdScience />,
};

const Channels = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { data: channelConnections, refetch } = useGetChannelConnections({});
  const agents = ((useSelector(getAgents) as any[]) || []) as any[];
  const agentsByID = new Map<number, any>(agents.map((a: any) => [a.id, a]));
  const [isDialogOpen, setIsDialogOpen] = useState(false);

  return (
    <div>
      <div className="mb-16 flex items-start justify-between">
        <div>
          <h3 className="mb-2">Каналы</h3>
          <p>
            Канал — это источник или точка коммуникации, откуда приходят сообщения пользователей и
            куда агент может отправлять ответы. Один канал привязывается к одному агенту.
          </p>
        </div>
        <Button
          variant="contained"
          color="primary"
          startIcon={<MdAdd />}
          onClick={() => setIsDialogOpen(true)}
        >
          Добавить канал
        </Button>
      </div>

      {channelConnections?.length === 0 ? (
        <Card>
          <CardContent>
            <Typography variant="body1" className="text-center">
              Нет подключённых каналов. Нажмите «Добавить канал», чтобы создать первый.
            </Typography>
          </CardContent>
        </Card>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-16">
          {channelConnections?.map((connection: any) => {
            const agent = agentsByID.get(connection.agentID);
            return (
              <Card key={connection.id}>
                <CardContent>
                  <div className="flex items-center w-full mb-4">
                    <div className="flex justify-center items-center mr-2 text-2xl">
                      {SOURCE_ICONS[connection.source] || <MdAdd />}
                    </div>
                    <Typography variant="body1" className="flex-grow">
                      {connection.source}
                    </Typography>
                    {connection.status === CHANNEL_STATUS.ACTIVE ? (
                      <FaCircle className="text-green-500 ml-2" size={12} />
                    ) : (
                      <FaCircle className="text-orange-500 ml-2" size={12} />
                    )}
                  </div>
                  <div className="mb-3 text-sm text-gray-600">
                    <div>
                      Агент: {connection.agentID ? agent?.name || `#${connection.agentID}` : "—"}
                    </div>
                    {connection.externalAccountUserName && (
                      <div>Аккаунт: {connection.externalAccountUserName}</div>
                    )}
                    {connection.connectionStatus && (
                      <div>Статус: {t(`CONNECTION_STATUS.${connection.connectionStatus}`)}</div>
                    )}
                  </div>
                  <Button
                    fullWidth
                    variant="text"
                    color="primary"
                    onClick={() => navigate(`/admin/channels/${connection.id}`)}
                  >
                    Детали
                  </Button>
                </CardContent>
              </Card>
            );
          })}
        </div>
      )}

      <CreateChannelDialog
        open={isDialogOpen}
        onClose={() => setIsDialogOpen(false)}
        onCreated={(channelConnectionID) => {
          setIsDialogOpen(false);
          refetch();
          navigate(`/admin/channels/${channelConnectionID}`);
        }}
      />
    </div>
  );
};

export default Channels;
